import {React, useContext, useState, useEffect} from 'react';
import { useTheme } from '@mui/material/styles';
import{UserContext} from '../../context/userContext/userContext'
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import {Divider, Button, Box, Typography, useMediaQuery} from '@mui/material/';
import axios from 'axios';
import { useStyle } from '../../context/styleContext/styleContext';
import { ShoppingCartContext } from '../../context/shoppingCartContext/shoppingCartContext';
import Rating from '@mui/material/Rating';
import KeyboardDoubleArrowRightRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowRightRounded';
import shoppingCartIcon from '../../images/shopping_cart.svg'

export default function HomePageProductCard({productData}) {

    const [data, setData] = useState();
    const { cartItems, cartSubtotal, addToCart } = useContext(ShoppingCartContext);
    const { style } = useStyle();
    const [width, setWidth] = useState(window.setWidth)
    

    useEffect(() => {
        function handleResize() {      
          setWidth(window.innerWidth)
      }
      
        window.addEventListener('resize', handleResize)
      })

    useEffect(() => {
        if(productData) {
            setData(productData)
        }
        
    }, [productData]);

    useEffect(() => {
        setWidth(window.innerWidth)
    }, []);

  //const [productData, setProductData] = useState();

  // const isMobile = width <= 768;
  const isMobile = useMediaQuery("(max-width: 768px)");

  const downloadMac = async (e) => {


    e.preventDefault()
          
          const dataToSend = {
            sku: productData.SKU,
            productName: productData.name,
            productVersion: "Mac " + productData.productVersion,
            downloadURI: "Product Card",
          }
  
          console.log("attemting download")
  
          try {
            const { data } = await axios.post('/log-download-attempt', dataToSend);
  
        } catch (error) {
  
        }
  
  
      window.location.href = productData.macDownloadURI
  }
  const logName = async (e) => {
    console.log(productData)
  }

  const addProductToCart = (e) => {
    e.preventDefault();
    addToCart(productData.SKU);
  };
  
  const downloadWindows = async (e) =>
      {
          //console.log("logging in...")
  
          e.preventDefault()
          
          const dataToSend = {
            sku: productData.SKU,
            productName: productData.name,
            productVersion: "Windows " + productData.productVersion,
            downloadURI: "Product Card",
          }
  
          console.log("attemting download")
  
          try {
            const { data } = await axios.post('/log-download-attempt', dataToSend);
  
        } catch (error) {
  
        }
  
  
      window.location.href = productData.windowsDownloadURI
  
  
      }
  



  return (<>
  
  {data && !isMobile &&(
    <Box style={{width:'100%', height:'100%'}}>
        <Typography variant="h3" sx={{ fontSize:"1.5rem", mb: 0.5, mt:0.5, fontWeight: "bold" }}>
        <a href={'products/' + productData.productURI}>{data.name}</a>
        </Typography>

<       Box sx={{ display:'flex', textAlign: "center", borderRadius:'8px', margin:'auto', minHeight:'200px'}}>
                <div style={{flex:'1', margin:'auto'}}>
                < a href={'products/' + productData.productURI}><img
                  src={productData.images[0]?.URI}
                  alt={productData.images[0]?.altText}
                  style={{
                    maxWidth:'200px',
                    borderRadius: 4,
                    objectFit: "contain",
                    backgroundColor:'rgba(0,0,0,.3)',
                    padding:'5px'
                  }}
                /></a>
                    
                </div>
        </Box>
        <Typography sx={{m:0.1}} variant='body1'>{productData.cardSummary}</Typography>
        <Typography sx={{mt:1, fontSize:'1.0rem'}} variant='body1'><strong>VST3 Plugin</strong></Typography>
        <Typography variant="h6" sx={{ml:1, mb:0.5, color: style.color4, fontSize:'1.6rem', textAlign:'left' }}>
        <strike  style={{fontSize:'1.5rem'}}>${(productData.msrp).toFixed(2)}</strike>
        </Typography>

        {productData.price > 0 && (
          <>
          <Typography variant="h6" sx={{ml:1, mb:0.5, color: style.color4, fontSize:'1.5rem', textAlign:'left' }}>
          <strong>${(productData.price).toFixed(2)}</strong>
          </Typography>
          <Button
                        onClick={addProductToCart}
                        sx={{
                          backgroundColor: style.color1,
                          color: style.color4,
                          border: `1px solid ${style.color2}`,
                          width:'95%',
                          mb:2,
                          filter:'brightness(1.05)',
                          boxShadow:10,
                          fontWeight:'bold',
                          fontSize:'.8rem',
                          "&:hover": { filter:'brightness(1.2)'},
                        }}
                      >
                        <img src={shoppingCartIcon} alt='Shopping cart icon' style={{ maxWidth:'20px', marginRight:'5px'}} />
                        Add to Cart
                      </Button>
                      <Button
                        href={'/products/' + productData.productURI}
                        sx={{
                          backgroundColor: style.color1,
                          color: style.color4,
                          border: `1px solid ${style.color2}`,
                          width:'95%',
                          filter:'brightness(1.05)',
                          boxShadow:10,
                          margin:'auto',
                          fontWeight:'bold',
                          fontSize:'.8rem',
                          "&:hover": { filter:'brightness(1.2)'},
                        }}
                      >
                        <KeyboardDoubleArrowRightRoundedIcon sx={{ fontSize:'1.5rem', marginRight:'5px'}}/>
                        Learn More
                      </Button>
          </>

        )}
        {productData.price < 0.01 && (

        <Typography variant="h6" sx={{ml:1, mb:2, color: style.color4, fontSize:'1.6rem', textAlign:'left' }}>
        <strong style={{fontSize:'1.6rem', color:'rgb(0,200,50)'}}> FREE </strong> <span style={{fontSize:'1rem'}}> (limited time)</span>
        </Typography>

        )}
        
  </Box>

  )}
  
  {data && isMobile &&(
    <Box sx={{width:'100%', height:'100%', display:'flex', flexDirection:'column'}}>
    <Box sx={{width:'100%', height:'100%', display:'flex', flexDirection:'row'}}>
        <Box>

<       Box sx={{ display:'flex', textAlign: "center",p:0.5, pl:0.5, pr:0.5, borderRadius:'8px', maxWidth:'300px', margin:'auto'}}>
                <div style={{flex:'1', margin:'auto'}}>
                < a href={'products/' + productData.productURI}><img
                  src={productData.images[0]?.URI}
                  alt={productData.images[0]?.altText}
                  style={{
                    maxHeight:'150px',
                    borderRadius: 4,
                    objectFit: "contain",
                    backgroundColor:'rgba(0,0,0,.3)',
                    padding:'5px'
                  }}
                /></a>
                    
                </div>
        </Box>
        <Box>

        </Box>
        </Box>
        <Box sx={{dislay:'flex', flexDirection:'column', textAlign:'left'}}>
        <Typography variant="h3" sx={{ fontSize:"1.5rem", mb: 0.5, mt:0.5, ml:2, fontWeight: "bold", textAlign:'left' }}>
        <a href={'products/' + productData.productURI}>{data.name}</a>
        </Typography>
        <Typography sx={{m:0.1, fontSize:'.8rem', mt:.5, textAlign:'left', ml:2}} variant='body1'>{productData.cardSummary}</Typography>
        <Typography sx={{mt:1, fontSize:'1.0rem', textAlign:'center'}} variant='body1'><strong>VST3 Plugin</strong></Typography>
        
        {productData.price > 0 && (
          <>
          <Typography variant="h6" sx={{ml:2, mb:0.5, color: style.color4, fontSize:'1.4rem', textAlign:'left' }}>
          <strike  style={{fontSize:'1.4rem'}}>${(productData.msrp).toFixed(2)}</strike>
          <strong style={{fontSize:'1.5rem', marginLeft:'10px'}}> ${(productData.price).toFixed(2)}</strong>
          </Typography>
          </>

          )}
          {productData.price < 0.01 && (
            <>
          <Typography variant="h6" sx={{ml:2, mb:1, color: style.color4, fontSize:'1.4rem', textAlign:'left' }}>
          <strong style={{fontSize:'1.4rem',color:'rgb(0,200,50)'}}> FREE </strong> <span style={{fontSize:'1rem'}}> (limited time)</span>
          </Typography>
          </>
          )}
</Box>
        
  </Box>

  {productData.price > 0.00 && (
  <Box sx={{display:'flex', flexDirection:'row'}}>
  <Button
                        onClick={addProductToCart}
                        sx={{
                          backgroundColor: style.color1,
                          color: style.color4,
                          border: `1px solid ${style.color2}`,
                          width:'95%',
                          margin:'auto',
                          filter:'brightness(1.05)',
                          boxShadow:10,
                          fontWeight:'bold',
                          fontSize:'.8rem',
                          "&:hover": { filter:'brightness(1.2)'},
                        }}
                      >
                        <img src={shoppingCartIcon} alt='Shopping cart icon' style={{ maxWidth:'20px', marginRight:'5px'}} />
                        Add to Cart
                      </Button>
                      <Button
                        href={'/products/' + productData.productURI}
                        sx={{
                          backgroundColor: style.color1,
                          color: style.color4,
                          border: `1px solid ${style.color2}`,
                          width:'95%',
                          margin:'auto',
                          filter:'brightness(1.05)',
                          boxShadow:10,
                          m:2,
                          fontWeight:'bold',
                          fontSize:'.8rem',
                          "&:hover": { filter:'brightness(1.2)'},
                        }}
                      >
                        <KeyboardDoubleArrowRightRoundedIcon sx={{ fontSize:'1.5rem', marginRight:'5px'}}/>
                        Learn More
                      </Button>
</Box>

  )}

{productData.price < 0.01 && (
  <Box sx={{display:'flex', flexDirection:'row', margin:'auto'}}>
  <Button sx={{flex:1, margin:'auto', minWidth:'200px', maxWidth:'150px', margin:'auto', mt:0.5, ml:0.2, mr:2, p:0.5,fontWeight:'bold', color:style.color4, backgroundColor:style.color2, filter:'brightness(1.05)',transition: 'filter 0.3s ease',  '&:hover': { filter: 'brightness(1.2)' } }} href={'products/' + productData.productURI}>Learn More</Button>

</Box>

  )}


  </Box>

  )}
  </>)}